import Select from "kreate-common/modules/kreate-ui/components/Select";
import * as React from "react";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  items: Record<string, React.ReactNode>; // Record<name: label>
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export default function Select$Collection({
  className,
  style,
  items,
  value,
  onChange,
  disabled,
}: Props) {
  return (
    <div className={className} style={style}>
      <Select
        options={Object.entries(items).map(([collectionName, label]) => ({
          value: collectionName,
          label,
        }))}
        value={value}
        onChange={onChange}
        minButtonWidth="160px"
        maxButtonWidth="252px"
        minContentWidth="300px"
        disabled={disabled}
      />
    </div>
  );
}
